import { Tag } from "../../store/model/tag.model";

export class TagsChangesEvent {

    type : 'ADD' | 'DELETE';
    tag : Tag;
    data : { listStatus : string, citationStatus : string };

    constructor(type : 'ADD' | 'DELETE', tag : Tag, data : { listStatus : string, citationStatus : string }){
        this.type = type;
        this.tag = tag;
        this.data = data;
    }
}
